import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './styles.module.less'
import { getKioskDocument } from 'src/utils/helpers'

const FontAwesomeIconComponent = ({
  icon = '',
  size = 'md',
  addClassName = '',
  type = 'primary',
  width = 0,
  color,
  onClick = () => {},
}) => {
  const getIconColor = () => {
    const doc = getKioskDocument()
    return getComputedStyle(doc.documentElement).getPropertyValue(`--chakra-colors-${type}`)
  }

  const classNames = classnames({
    e: true,
    [styles.icon]: true,
    [styles[size]]: true,
    [addClassName]: !!addClassName,
    [styles[`width-${width}`]]: width,
  })
  return icon && icon[1].length ? (
    <FontAwesomeIcon
      icon={icon}
      className={classNames}
      color={color || getIconColor()}
      onClick={onClick}
    />
  ) : null
}

FontAwesomeIcon.PropTypes = {
  icon: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xlg']),
  addClassName: PropTypes.string,
}

export default FontAwesomeIconComponent
